module.exports = __webpack_public_path__ + "img/dotCover_icon.561cc49f.png";